'use strict';

const OpsWizardCtrl = function ($rootScope, config) {
  var ctrl = this;

  ctrl.formDef = config.opsWizardSchema;

  ctrl.data = {};

  ctrl.$onChanges = function (foo) {
  };

  ctrl.submitOps = function () {
    $rootScope.$broadcast('treatmentform:updateValue',
      {
        "key": ctrl.codeField,
        "value": collectOpsCodes(ctrl.data) + ""
      });

    $rootScope.$broadcast('treatmentform:updateValue',
      {
        "key": ctrl.stringField,
        "value": collectOpsStrings(ctrl.data) + ""
      });
  },
  ctrl.resetForm = function(){
    ctrl.data = {};
  };

  let collectOpsCodes = function (form) {
    var finalCodes = [];

    if (form.length === 0) {
      return "Fehler - leer";
    }
    var opsCodes = [].concat.apply([], Object.keys(form).map(key => form[key]));

    // replace placeholders (**) with given region
    opsCodes.forEach((code) => {
      if (code.indexOf("**", code.length - 2) !== -1 && ctrl.region && ctrl.region.length > 0) {
        let regionCode = fetchRegion(code, ctrl.region);
        if(regionCode){
          finalCodes.push(code.replace("**", regionCode));
        }
      } else {
        finalCodes.push(code);
      }
    });

    return finalCodes;
  },

  fetchRegion = function(code, region){
    let regObj = config.opsRegionen[region];
    for (var property in regObj) {
      if (regObj.hasOwnProperty(property)) {
          if(code === property){
            return regObj[property];
          }
      }
    }
    if(regObj.hasOwnProperty('default')){
      return regObj['default'];
    }
    return undefined;
  },

  collectOpsStrings = function (form) {
    if (form.length === 0) {
      return "Fehler - leer";
    }
    var opsCodes = [].concat.apply([], Object.keys(form).map(key => form[key]));
    return opsCodes.map(code => config.opsCodes[code]).join(" + ");
  };
};

OpsWizardCtrl.$inject = ['$rootScope', 'config'];

module.exports = {
  template: require('./ops-wizard.html'),
  bindings: {
    'codeField': '<',
    'stringField': '<',
    'region': '<'
  },
  controller: OpsWizardCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/ops-wizard/ops-wizard.component.js